/*global SVGPathElement*/
(function () {
    'use strict';

    var lastStart;

    function touchHandler(event) {
        var first = event.changedTouches[0];
        if (!isMapChild(first.target) || !event.target instanceof SVGPathElement) {
            return;
        }
        if (event.type === 'touchstart') {
            lastStart = Date.now();
            return;
        }
        if (event.type === 'touchend') {
            if (Date.now() - lastStart < 200 && event.target.e_graphic) {
                event.target.graphic = event.target.e_graphic;
                event.target.mapPoint = angular.copy(event.target.e_graphic.geometry);
                first.target.e_graphic._layer.onClick(event.target);
            }
        }

    }

    function isMapChild(element) {
        var svgs = angular.element(document).find('svg');
        for (var i = 0; i < svgs.length; i++) {
            if (svgs[i].id.search('esri.Map') != -1 && svgs[i].contains(element)) {
                return true;
            }
        }
        return false;
    }

    document.addEventListener('touchstart', touchHandler, true);
    document.addEventListener('touchend', touchHandler, true);

})();
